import { apiHost } from '@/server/urls';

export const useFileUrlPreHost = () => (url) => {
    if (!url.startsWith('http') && !url.startsWith('https')) {
        if (!url.startsWith('/')) {
            url = `/${url}`;
        }
        return `${apiHost}${url}`;
    }
    return url;
};
